export enum CustomerType {
    Owner = 'Owner',
    User = 'User'
}
